import Bali from "../images/bali.jpg";
import Paris from "../images/paris.jpg";
import Maldives from "../images/maldives.jpg";
import SectionHeading from "./ui/SectionHeading";
import Reveal from "./ui/Reveal";

const Destinations = () => {
  const places = [
    { src: Bali, name: "Bali" },
    { src: Paris, name: "Paris" },
    { src: Maldives, name: "Maldives" },
  ];
  return (
    <section id="destinations" className="section-pad bg-[#eef5ea]">
      <SectionHeading
        eyebrow="Explore the World"
        title="Popular Destinations"
        subtitle="Beyond the holy journey — discover stunning destinations curated just for you."
      />
      <div className="mx-auto grid max-w-5xl grid-cols-1 gap-6 sm:grid-cols-2 sm:gap-8 md:grid-cols-3">
        {places.map((place, i) => (
          <Reveal key={place.name} delay={i * 0.1}>
            <div className="group relative h-72 overflow-hidden rounded-2xl shadow-soft">
              <img
                src={place.src}
                alt={place.name}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/85 via-brand-dark/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-5 text-left">
                <h4 className="text-xl font-bold text-white">
                  <span className="text-brand-gold">{place.name}</span>
                </h4>
                <p className="mt-1 text-sm text-white/80">
                  Experience the beauty of {place.name} like never before.
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Destinations;
